<template>
  <div class="expandable-list">
    <div class="list-header" @click="toggle" :class="{ disabled: disabled, open: isOpen}">
        <h4 @close="open = false">{{title}}</h4>
        <hr />
        <i class="fa" aria-hidden="true" :class="{'fa-angle-up': isOpen, 'fa-angle-down': !isOpen}" style="font-size:24px"></i>
        <!-- <i v-show="!noIcon" class="glyphicon" ></i> -->
    </div>
    <div v-show="isOpen" class="padding-bottom-1">
        <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'expandableList',
  props: ['title', 'open', 'noIcon', 'disabled'],
  data () {
    return {
        isOpen: this.open
    }
  },
  methods: {
      toggle: function () {
        this.isOpen = this.disabled ? this.isOpen : !this.isOpen
        if (this.isOpen) this.$emit('expanded')
      }
  }
}
</script>

<style lang="less" scoped>
  .expandable-list {
    .list-header {
        cursor: pointer;
        display: flex;
        align-items: center;
        text-transform: uppercase;
        font-weight: bold;
        color: #616161;
        padding-bottom: 16px;

        h4 {
            font-size: 13px;
            margin: 0;
            line-height: 20px;
        }

        &.disabled {
            cursor: auto
        }

        hr {
            flex: 1;
            margin: 0 0 0 15px;
        }
        i {
            margin-left: 15px;
            color: #c5c5c5;
            font-size: 15px;
            line-height: 12px;
            position: relative;
            &.glyphicon-menu-down {
                top: -1px;
            }
            
        }
    }
    .list-element {
        &:not(:last-child), &:only-child {
            margin: 15px 0;
        }   
    }

    &.compact .list-element {
        &:not(:last-child), &:only-child {
            margin: 10px 0;
        }   
    }
  }
</style>
